import { useEffect, useState } from 'react';
import getUserPreferredLanguage from './i18n/getUserPreferredLanguage';
import { resetCache } from './i18n/messageCache';
import useNotificationCookie from './useNotificationCookie';
import useIsESigLoginContext from './useIsESigLoginContext';
import useLoginPrefillUser from './useLoginPrefillUser';

function getInitialValue(isESigLoginContext, loginPrefillUserLanguage, notificationCookieLanguage) {
    const localStorageLanguage = localStorage.getItem('i18n.unauthenticatedRouteLanguage');
    let initialValue = getUserPreferredLanguage();
    if (isESigLoginContext) {
        initialValue = 'en';
    } else if (loginPrefillUserLanguage) {
        initialValue = loginPrefillUserLanguage;
    } else if (notificationCookieLanguage) {
        initialValue = notificationCookieLanguage;
    } else if (localStorageLanguage) {
        initialValue = localStorageLanguage;
    }
    return initialValue;
}

export default function useUnauthenticatedRouteLanguage() {
    const isESigLoginContext = useIsESigLoginContext();
    const [loginPrefillUser] = useLoginPrefillUser();
    const notificationCookie = useNotificationCookie();

    const notificationCookieLanguage = notificationCookie?.language;
    const loginPrefillUserLanguage = loginPrefillUser?.language;
    const initialLanguageValue = getInitialValue(
        isESigLoginContext,
        loginPrefillUserLanguage,
        notificationCookieLanguage,
    );

    const [language, setLanguage] = useState(initialLanguageValue);

    useEffect(() => {
        localStorage.setItem('i18n.unauthenticatedRouteLanguage', language);
    }, [language]);

    const handleLanguageChange = (value) => {
        if (value !== language) {
            resetCache();
            setLanguage(value);
        }
    };

    return [language, handleLanguageChange];
}
